import React from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CartFormValues } from "./types";
import { IonToggle } from "@ionic/react";

interface LeaveAtDoorToggleProps {
  control: Control<CartFormValues>;
}

export const LeaveAtDoorToggle = ({ control }: LeaveAtDoorToggleProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="leaveAtDoor"
      control={control}
      render={({ field: { onChange, value } }) => (
        <div className="flex items-center justify-between px-2.5 py-4 !border-b-1 !border-b-solid !border-b-[#e5e7eb]">
          <div className="text-[#292929]">{t("Leave at door")}</div>
          <IonToggle
            mode="ios"
            onIonChange={(e) => {
              onChange(!value);
            }}
            checked={value}
            color="success"
          />
        </div>
      )}
    />
  );
};
